import { merge } from 'lodash';
import MUIDataTable from './MUIDataTable';

export default function ComponentsOverrides() {
  return merge(MUIDataTable());
}
